module.exports = __webpack_public_path__ + "img/waddelhall-474x632.209e9682.jpg";